import { $applyNodeReplacement, TextNode } from "lexical";

import type {
  DOMConversionMap,
  EditorConfig,
  LexicalNode,
  LexicalUpdateJSON,
  SerializedTextNode,
} from "lexical";

const HIGHLIGHT_COLOUR = "#FFFF00";

export class NonGsmHighlightNode extends TextNode {
  static getType(): string {
    return "non-gsm-highlight";
  }

  static clone(node: NonGsmHighlightNode): NonGsmHighlightNode {
    return new NonGsmHighlightNode(node.__text, node.__key);
  }

  static importJSON(serializedNode: SerializedTextNode): NonGsmHighlightNode {
    return $createNonGsmHighlightNode(serializedNode.text).updateFromJSON(serializedNode);
  }

  static importDOM(): DOMConversionMap | null {
    return null;
  }

  updateFromJSON(serializedNode: LexicalUpdateJSON<SerializedTextNode>): this {
    return super.updateFromJSON(serializedNode);
  }

  createDOM(config: EditorConfig): HTMLElement {
    const dom = super.createDOM(config);
    this.applyHighlight(dom);
    return dom;
  }

  updateDOM(prevNode: this, dom: HTMLElement, config: EditorConfig): boolean {
    const needsReplacement = super.updateDOM(prevNode, dom, config);
    // super.updateDOM rewrites inline styles when the node's own style
    // changes, so the highlight has to be reapplied.
    this.applyHighlight(dom);
    return needsReplacement;
  }

  /**
   * Set only the background so any inline styles Lexical manages for this node,
   * rather than overwriting `style.cssText` wholesale.
   */
  applyHighlight(dom: HTMLElement): void {
    dom.style.backgroundColor = HIGHLIGHT_COLOUR;
    dom.classList.add("non-gsm-highlight");
  }
}

export function $createNonGsmHighlightNode(text: string): NonGsmHighlightNode {
  return $applyNodeReplacement(new NonGsmHighlightNode(text));
}

export function $isNonGsmHighlightNode(node?: LexicalNode | null): node is NonGsmHighlightNode {
  return node instanceof NonGsmHighlightNode;
}
